import React from 'react';
import { STATUS_PLAYER_WON, STATUS_COMPUTER_WON } from './constants';

const GameInfoPanel = ({ message, gameStatus, gameTurn }) => {
    const getMessageColor = () => {
        if (gameStatus === STATUS_PLAYER_WON) return 'green';
        if (gameStatus === STATUS_COMPUTER_WON) return 'red';
        return 'black';
    };

    return (
        <div style={{ minHeight: '2em', fontSize: '1.125rem', marginBottom: '0.5rem', fontWeight: 'bold', color: getMessageColor() }}>
             {message} {gameStatus === 'PLAYING' && `(Turn: ${gameTurn})`}
        </div>
    );
};

export default GameInfoPanel;